import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { useChemicalProductStyles } from '../ChemicalProduct.styles';

interface IHazardsProps {
  expanded: boolean;
  hazardStatements?: string;
  hazardClassification?: string;
  precautionaryStatements?: string
  otherHazards?: string,
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const Hazards: React.FC<IHazardsProps> = ({
  expanded,
  hazardStatements,
  hazardClassification,
  precautionaryStatements,
  otherHazards,
  handleChange,
}): JSX.Element => {
  const { t } = useTranslation();
  const classes = useChemicalProductStyles({});

  return (
    <Accordion
      expanded={expanded}
      onChange={handleChange(`panel3`)}
      key={'panel3'}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel3bh-content`}
        id={`panel3bh-header`}
      >
        <Typography className={classes.heading}>{t('chemicals.hazards')}</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.hazardsList}>
        {hazardClassification && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.hazard_classification')}</b> ${hazardClassification}` }} />
        )}
        {hazardStatements && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.hazard_statements')}</b> ${hazardStatements}` }} />
        )}
        {precautionaryStatements && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.precautionary_statements')}</b> ${precautionaryStatements}` }} />
        )}
        {otherHazards && (
          <Typography dangerouslySetInnerHTML={{ __html: `<b>${t('chemicals.other_hazards')}</b> ${otherHazards}` }} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default Hazards;
